module.exports = __webpack_public_path__ + "img/_blanc.255efb5f.jpg";